import { getVal } from 'react-redux-firebase';
import dayjs from 'dayjs';
import { createSelector } from 'reselect';

/**
 * Locale code input selector
 * @param {Object} state redux state
 */
const getLocale = (state, props) => props.activeLanguage.code;

const getQueryParams = (state, props) => props.location.search;

const getGame = state =>
  getVal(state.firebase.data, `/games/${state.global.gameId}`);

/**
 * Month input selector
 * @param {Object} state component state
 * @param {Object} props component props
 */
const getDate = createSelector(getQueryParams, search => {
  const params = new URLSearchParams(search);
  return params.get('time');
});

function getValidDate(rawDate, game) {
  const date = dayjs.unix(rawDate);
  if (rawDate && date.isValid()) {
    return date;
  }
  const today = dayjs();
  if (game && game.startDate) {
    const startDate = dayjs(game.startDate);
    if (startDate.isValid() && today.isBefore(startDate)) {
      return startDate;
    }
  }
  return today;
}

/**
 * Localized month memoized selector
 */
export const getLocalizedDate = createSelector(
  [getLocale, getDate, getGame],
  (locale, rawDate, game) => {
    return getValidDate(rawDate, game).locale(locale);
  }
);
